import React, { Component } from 'react';

class FormSubmittedModal extends Component {

    render() {


        return (
            <div id="formSubmitted" className="modal fade" role="dialog">
                <div className="modal-dialog text-center">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                            <img src="/images/popup-confirm.png" className="padding-top" />
                        </div>
                        <div className="modal-body">
                            <p className="p-tag">Thanks, your details have been submitted successfully.</p>

                        </div>

                    </div>
                </div>

            </div>
        )
    }
}

export default FormSubmittedModal;


// WEBPACK FOOTER //
// src/client/components/common/elements/FormSubmittedModal.js